export default __webpack_public_path__ + "static/media/ic-test.fdae3389.svg";